(function(){
  var sheet=document.getElementById('welcome-offer');
  if(!sheet)return;

  var seen=false;
  var previousFocus=null;
  var timer=null;
  var currentUrl=null;
  var couponCatalog={
    Gilvinte:{code:'Gilvinte',value:'15%'},
    Luvinte:{code:'Luvinte',value:'20%'}
  };
  var redeemedCoupon=null;
  var requestedCoupon='';
  try{currentUrl=new URL(window.location.href);}catch(error){}
  if(currentUrl&&currentUrl.searchParams.has('coupon_link')){
    requestedCoupon=currentUrl.searchParams.get('coupon_link')||'';
    currentUrl.searchParams.delete('coupon_link');
    try{history.replaceState(history.state,'',currentUrl.pathname+currentUrl.search+currentUrl.hash);}catch(error){}
  }
  try{
    var storedCoupon=sessionStorage.getItem('adl_redeemed_coupon')||'';
    sessionStorage.removeItem('adl_redeemed_coupon');
    if(!requestedCoupon)requestedCoupon=storedCoupon;
  }catch(error){}
  if(requestedCoupon.toLowerCase()==='gilvinte')redeemedCoupon=couponCatalog.Gilvinte;
  if(requestedCoupon.toLowerCase()==='luvinte')redeemedCoupon=couponCatalog.Luvinte;
  try{seen=localStorage.getItem('adl_welcome_seen')==='1';}catch(error){}

  function remember(){
    try{localStorage.setItem('adl_welcome_seen','1');}catch(error){}
  }

  function open(){
    previousFocus=document.activeElement;
    document.body.classList.add('welcome-offer-open');
    sheet.hidden=false;
    sheet.setAttribute('aria-hidden','false');
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    remember();
    var primary=sheet.querySelector('[data-welcome-copy]');
    if(primary)primary.focus();
  }

  function close(){
    clearTimeout(timer);
    document.body.classList.remove('welcome-offer-open');
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden','true');
    remember();
    setTimeout(function(){
      sheet.hidden=true;
      if(previousFocus&&previousFocus.focus)previousFocus.focus();
    },420);
  }

  function copyCoupon(code){
    if(navigator.clipboard&&window.isSecureContext){
      return navigator.clipboard.writeText(code);
    }
    var field=document.createElement('textarea');
    field.value=code;
    field.setAttribute('readonly','');
    field.style.position='fixed';
    field.style.opacity='0';
    document.body.appendChild(field);
    field.select();
    document.execCommand('copy');
    field.remove();
    return Promise.resolve();
  }

  function configureCouponSuccess(details){
    sheet.setAttribute('data-mode','coupon-success');
    sheet.setAttribute('data-coupon-code',details.code);

    var badge=sheet.querySelector('[data-welcome-badge]');
    var title=sheet.querySelector('[data-welcome-title]');
    var text=sheet.querySelector('[data-welcome-text]');
    var codeLabel=sheet.querySelector('[data-welcome-code-label]');
    var code=sheet.querySelector('[data-welcome-code]');
    var value=sheet.querySelector('[data-welcome-value]');
    var valueLabel=sheet.querySelector('[data-welcome-value-label]');
    var button=sheet.querySelector('[data-welcome-primary]');
    var secondary=sheet.querySelector('[data-welcome-secondary]');

    if(badge)badge.textContent='Cupom ativado';
    if(title)title.textContent='Cupom resgatado com sucesso!';
    if(text)text.textContent='Bem-vindo à Arte dos Livros. Seu desconto já está ativo — aproveite para descobrir sua próxima grande leitura.';
    if(codeLabel)codeLabel.textContent='Cupom aplicado';
    if(code)code.textContent=details.code;
    if(value)value.textContent=details.value;
    if(valueLabel)valueLabel.textContent='desconto ativo';
    if(button){
      button.textContent='Explorar a livraria';
      button.onclick=function(event){
        event.preventDefault();
        event.stopPropagation();
        close();
      };
    }
    if(secondary)secondary.hidden=true;
  }

  if(redeemedCoupon){
    configureCouponSuccess(redeemedCoupon);
    open();
  }else if(!seen&&matchMedia('(max-width:720px)').matches){
    timer=setTimeout(open,10000);
  }

  sheet.addEventListener('click',function(e){
    if(e.target.closest('[data-welcome-offer-close]')){
      close();
      return;
    }

    var button=e.target.closest('[data-welcome-copy]');
    if(!button)return;

    if(sheet.getAttribute('data-mode')==='coupon-success'){
      close();
      return;
    }

    var code=sheet.getAttribute('data-coupon-code');
    var destination=sheet.getAttribute('data-destination')||'/collections/all?sort_by=best-selling';
    remember();
    copyCoupon(code).then(function(){
      button.textContent='Cupom copiado!';
      close();
      setTimeout(function(){location.assign(destination);},500);
    }).catch(function(){
      button.textContent='Use o código '+code;
    });
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&sheet.classList.contains('is-open'))close();
  });
})();
